import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Warehousing from "../components/Warehousing"
import userGl from "../components/userGl"
import Warehouse from "../components/Warehouse"
import QueryPricing from "../components/QueryPricing"
import Stock from "../components/Stock"
import CashFlows from "../components/CashFlows"
import DengL from "../components/DengL"  
import NameList from "../components/NameList" 
import JobWork from "../components/JobWork"
import RoleManagement from "../components/RoleManagement" 
import LabelManagement from "../components/LabelManagement"
import Wxuser from '../components/wxUser.vue'
Vue.use(Router)

const routes = [
    {path: '/DengL',component: DengL},
    {
        path: '/',component: Index,
         redirect:'/Warehousing',
        children:[
            {path: '/Wxuser',component: Wxuser},
            {path: '/Warehousing',component: Warehousing},
            {path: 'NameList',component: NameList},
            {path: '/userGl',component: userGl},
            {path: '/Warehouse',component: Warehouse},
            {path: '/QueryPricing',component: QueryPricing},
            {path: '/Stock',component: Stock},
            {path: '/CashFlows',component: CashFlows},
            {path: '/JobWork',component: JobWork},
            {path: '/RoleManagement',component: RoleManagement},
            {path: '/LabelManagement',component: LabelManagement},
        ]
    },
]

const router = new Router({
    mode: 'history',
    routes
  })


router.beforeEach((to, from, next) => {
    /* 路径跳转处理 */
    //console.log(JSON.parse(localStorage.getItem('userInfo')))
    if (!JSON.parse(localStorage.getItem('userInfo'))) {
        if(to.path!='/DengL'){
            next({path: '/DengL'})
            setTimeout('console.clear',300)
        }else{
            next();
        }
    } else {
        next()
    }
})
  
export default router




// WEBPACK FOOTER //
// ./src/router/index.js